.fileLayoutIcon {
	border: 1px solid #e8e8e8;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 28px;
	width: 28px;
	border-radius: 4px;
	flex-shrink: 0;

	& svg {
		color: #42296e;
	}
}

.fileLayoutSliderContainer {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	width: 100%;
}
